import React from 'react';

import { observer } from 'mobx-react-lite';

import useRouter from '@vromo/hooks/useRouter';

import Modal, { ModalHeader, ModalContent, ModalActions } from '@vromo/ui/components/Modal';
import Title from '@vromo/ui/components/Title';
import Button from '@vromo/ui/components/Button';
import Clipboard from '@vromo/ui/components/Clipboard';
import { useStore } from '@vromo/mobx-react/mobx-react';
import { RootStore } from '../stores/RootStore';
import { css } from 'emotion';
import FontAwesome from '@vromo/ui/components/FontAwesome';
import theme from '@vromo/ui/components/theme';
import { qaLabelTestSites } from '../../../../../common-qa-labels/sites';

type Props = {
    isOpen: boolean;
    type: 'form' | 'map';
    onRequestClose: () => void;
    token: string | null;
};
export default observer<Props>(function SiteTokenModal({ isOpen, onRequestClose, token, type }) {
    const currentHost = window.location.host;

    const {
        authStore: {
            user: { apiHost }
        }
    } = useStore<RootStore>('rootStore');

    return (
        <Modal isOpen={isOpen} onRequestClose={onRequestClose} showCloseButton={false}>
            <ModalHeader>
                <div style={{ display: 'flex', justifyContent: 'center' }}>
                    <FontAwesome
                        icon={type === 'form' ? 'clipboard-list' : 'map-marked-alt'}
                        style={{ color: theme.primary, fontSize: '5rem' }}
                        weight="regular"
                    />
                </div>
            </ModalHeader>
            <ModalContent
                className={css`
                    text-align: center;
                    p {
                        font-size: 1rem;
                    }
                `}>
                {type === 'form' ? (
                    <>
                        <p data-testid={qaLabelTestSites.editSiteModal.linkModal.jobRequestText}>Here's the link to the job request form for this site:</p>
                        <Clipboard data-testid={qaLabelTestSites.editSiteModal.linkModal.linkInput}
                            value={`https://${currentHost}/job-request/${token}?host=${apiHost}`}
                            toastMessage="Form Link Copied!"
                        />
                        <p>Give this link to your site so they can start requesting jobs.</p>
                    </>
                ) : (
                    <>
                        <p data-testid={qaLabelTestSites.editSiteModal.linkModal.liveSiteViewText}>Here's the link to the live view for this site:</p>
                        <Clipboard
                            value={`https://${currentHost}/live-site/${token}?host=${apiHost}`}
                            toastMessage="Live View Link Copied!"
                        />
                        <p>
                            Give this link to your site so they can track their jobs and drivers in
                            real time.
                        </p>
                    </>
                )}
            </ModalContent>
            <ModalActions>
                <Button onClick={onRequestClose}  data-testid={qaLabelTestSites.editSiteModal.linkModal.closeBtn}>Close</Button>
            </ModalActions>
        </Modal>
    );
});
